module.exports = __webpack_public_path__ + "img/development-during-recession-top.a01e21dc.webp";